module.exports = __webpack_public_path__ + "img/exit-fullscreen.810dcbfe.svg";